import { useCallback } from 'react';
import { StepsEnum } from 'src/types';
import { useDataContext } from 'src/contexts';

export const useSteps = () => {
  const activeStep = useDataContext(
    (ctx) => ctx.activeStep ?? StepsEnum.INITIALIZATION
  );
  const previousStep = useDataContext((ctx) => ctx.previousStep ?? null);
  const setActiveStep = useDataContext((ctx) => ctx.setActiveStep);

  const nextStep = useCallback(() => {
    const currentValue = activeStep;
    const nextValue = currentValue + 1;

    const enumValues = Object.values(StepsEnum).filter(
      (v) => typeof v === 'number'
    ) as number[];

    if (enumValues.includes(nextValue)) {
      setActiveStep(nextValue as StepsEnum);
    }
  }, [activeStep, setActiveStep]);

  const prevStep = useCallback(() => {
    const currentValue = activeStep;
    const prevValue = currentValue - 1;

    const enumValues = Object.values(StepsEnum).filter(
      (v) => typeof v === 'number'
    ) as number[];

    if (prevValue >= 0 && enumValues.includes(prevValue)) {
      setActiveStep(prevValue as StepsEnum);
    }
  }, [activeStep, setActiveStep]);

  const setStep = useCallback(
    (step: StepsEnum) => {
      setActiveStep(step);
    },
    [setActiveStep]
  );

  return {
    activeStep,
    previousStep,
    nextStep,
    prevStep,
    setStep,
  };
};
